import { Container } from "@components/Container/Container";
import { Module } from "@components/Module/Module";
import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { ImageField } from "@helpers/interfaces/image";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { Box } from "@components/Box/Box";
import { Heading } from "@components/Heading/Heading";
import { AspectRatio } from "@components/AspectRatio/AspectRatio";
import { VideoField } from "@helpers/interfaces/media";
import { UmbracoVideo } from "@components/UmbracoVideo/UmbracoVideo";
export interface FactBoxProps {
  Title?: string;
  Description?: string;
  Media?: {
    Image?: ImageField;
    Video?: VideoField;
  };
  BorderColor?: string;
}

const FactBox: React.FC<FactBoxProps> = ({
  Title,
  Description,
  Media,
  BorderColor
}) => {
  return (
    <Module animate>
      <Container variant="small" smallpad>
        {Media && Media.Image && (
          <AspectRatio ratio={"4:3"}>
            <UmbracoImage
              image={Media.Image}
              width={[300, 640, 640, 640]}
              isCover
            />
          </AspectRatio>
        )}
        {Media && Media.Video && (
          <AspectRatio ratio={"16:9"}>
            <UmbracoVideo video={Media.Video} />
          </AspectRatio>
        )}
        <Box
          className={classNames(styles.factbox)}
          {...(BorderColor && {
            style: { borderLeftColor: BorderColor }
          })}
        >
          {Title && <Heading as="h2">{Title}</Heading>}
          {Description && (
            <Box dangerouslySetInnerHTML={{ __html: Description }} />
          )}
        </Box>
      </Container>
    </Module>
  );
};
export { FactBox };
